<template>
  <div>
    <via-nav-bar
      :title="$route.query.title ? $route.query.title + '列表' : '插件列表'"
      @click-left="$router.$back()"
    />
    <via-plugin-list
      :refreshing.sync="refreshing"
      :loading.sync="loading"
      :finished="finished"
      :list="plugins"
      :skeleton="false"
      @refresh="refresh"
      @load="listLoad"
    />
    <div
      v-show="showSkeleton"
      class="skeleton-box"
      :style="{ height: $vw(skeletonHeight) }"
    >
      <van-skeleton
        class="skeleton"
        title
        :row="10"
        :loading="true"
      />
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vant'
import ViaPluginList from 'components/common/via-plugin-list.vue'

export default {
  name: 'SortDetail',
  components: {
    [ViaPluginList.name]: ViaPluginList,
    [Skeleton.name]: Skeleton
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: true,
      currentPage: 0,
      plugins: [],
      tagId: null,
      showSkeleton: true,
      requesting: false,
      timerId: null
    }
  },
  computed: {
    // return rpx
    skeletonHeight() {
      return this.$pxToRpx(this.$clientHeight) - 46
    }
  },
  mounted() {
    this.tagId = this.$route.params.id
    this.timerId = setTimeout(() => {
      this.showSkeleton = false
      this.finished = false
    }, 500)
  },
  // 缓存组件show
  activated() {
    if (this.tagId !== this.$route.params.id) {
      this.tagId = this.$route.params.id
      this.showSkeleton = true
      this.refresh()
    }
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    refresh() {
      // 坑: finished从true变回false会立即加载一次, 所以记录旧的finished状态
      const isFinished = this.finished
      this.currentPage = 0
      this.loading = false
      if (!isFinished) {
        this.listLoad()
        this.plugins = []
      } else {
        this.timerId = setTimeout(() => {
          this.finished = false
          this.plugins = []
        }, 500)
      }
    },
    listLoad() {
      if (this.finished || this.requesting) {
        return
      }
      this.requesting = true
      this.currentPage = this.currentPage + 1
      this.$api.plugin.findByTag({ tagId: this.$route.params.id, page: this.currentPage }).then(res => {
        this.loading = false
        this.requesting = false
        // 刷新成功
        if (this.refreshing) {
          this.$toast.success('刷新成功')
          this.refreshing = false
        }
        this.plugins = this.plugins.concat(res.data)
        if (!res.data || res.data.length < 20) {
          this.finished = true
        }
        this.showSkeleton = false
      }).catch(() => {
        if (this.refreshing) {
          this.$toast.fail('刷新失败')
          this.refreshing = false
        } else {
          this.$toast.fail('加载列表失败')
        }
        this.requesting = false
        this.loading = false
        this.showSkeleton = false
      })
    }
  }
}
</script>

<style scoped>
.skeleton-box {
  position: fixed;
  top: 46px;
  left: 0;
  z-index: 999;
  width: 375px;
  background-color: var(--light100);
}
.skeleton {
  margin-top: 15px;
}
</style>
